import * as React from 'react';
const SvgTechnicalInfrastructure = (props) => (
  <svg viewBox="0 0 124 121" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M99.95 83.648v13.294H76.78c-6.145 0-11.128 5.024-11.128 11.219 0 1.738 1.401 3.151 3.126 3.151h35.613c5.939 0 10.755-4.856 10.755-10.843v-17.24c0-8.596-5.708-15.853-13.514-18.115-2.812-.815-5.845-.321-8.34 1.23a10.569 10.569 0 0 1-11.171 0c-2.494-1.551-5.527-2.045-8.34-1.23-7.806 2.262-13.514 9.52-13.514 18.115v1.773c0 3.048-2.45 5.518-5.473 5.518h-7.757M16.65 111.312 3.42 78.462h30.87M47.52 111.312l-13.23-32.85M60.26 111.312H16.65M3.42 118.722H122M102.724 43.353c1.382.42 1.984 2.495 1.347 4.634-.637 2.144-2.273 3.537-3.655 3.122-2.367 6.2-6.968 10.404-12.27 10.404-5.301 0-9.907-4.21-12.274-10.404-1.382.42-3.018-.978-3.655-3.122s-.034-4.218 1.347-4.634"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.804 45.611c-.588-1.99-1.387-5.71-.446-10.072.152-.697 2.685-11.62 11.99-13.951 4.969-1.245 10.687.252 14.21 4.031a13.31 13.31 0 0 1 2.073 2.944c.073.035.21.124.392.247 2.989 2.11 4.659 5.74 4.429 9.51-.117 1.97-.465 5.048-.465 6.273"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.559 43.353c3.263-2.084 7.501-5.073 9.961-8.071 4.993 4.57 12.108 7.928 18.85 8.072M44.58 102.915h22.05M75.744 16.337l-5.238-5.28-8.168 6.11a33.026 33.026 0 0 0-10.3-4.303l-1.49-10.142H38.643l-1.49 10.142a32.928 32.928 0 0 0-10.3 4.303l-8.168-6.11-8.418 8.486 6.061 8.235a33.592 33.592 0 0 0-4.267 10.384L2 39.663v12.005l10.06 1.501a33.492 33.492 0 0 0 4.267 10.384l-6.06 8.235"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.844 61.513a18.669 18.669 0 0 1-8.746-15.848c0-10.294 8.28-18.643 18.492-18.643 6.385 0 12.01 3.26 15.337 8.22"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgTechnicalInfrastructure;
